import * as Types from '../constants/Types';
import Order, { OrderItem, OrderSurchargeItem, RedeemTourOrder } from '../models/Order';
import Flight from '../models/Flight';
import { PAGINATION } from '../constants/Define';
import { findIndex } from 'lodash';
import { setSurchargeHotel } from '../utils/orders';

const initialState = {
    onSubmitting: false,
    isSubmit: false,
    isSubmitSaleOrder: false,
    isFail: false,
    isGetItem: false,
    isFetching: false,
    isFetchingDownload: false,
    isFetchingItems: false,
    isFetchingFlight: false,
    isFetchingHotel: false,
    isFetchingSaleOrder: false,
    isFetchingGetDetailVoucher: false,
    isFetchingUpdate: false,
    isFetchingEmail: false,
    isFetchingEditFlight: false,
    isFetchingUpdateProfile: false,
    isFetchingVinwonderCustomers: false,
    isFetchingSmsHistories: false,
    isResendSms: false,
    data: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
    },
    detail: {
        order: new Order(),
        orderItem: new OrderItem(),
        voucherItems: [],
        voucherFilters: {
            status: undefined,
            pageSize: PAGINATION.pageSize,
            pageIndex: PAGINATION.pageIndex,
            totalCount: PAGINATION.totalCount,
            orderBy: undefined,
            orderByDesc: false,
        },
        flight: new Flight(),
        surcharges: [],
        reservations: [],
        bundleOrderSurcharge: {
          pageSize: PAGINATION.pageSize,
          pageIndex: PAGINATION.pageIndex,
          totalCount: PAGINATION.totalCount,
          totalPage: 0,
        },
        surcharge: new OrderSurchargeItem(),
        redeemData: new RedeemTourOrder(),
        customers: [],
        smsHistories: [],
        flightTrackingOrder: []
    },
    openModalDetail: false,
    totalPrice: {
        totalSurcharge: 0,
        totalAmount: 0,
        totalChangeRateCode: 0,
    },
    isFetchingRecommit: false,
    isFetchingUpdateOrderStatus: false,
    isFetchingCheckRedeem: false,
    recommitErr: null,
    isPushingFixedCharge: false,
    isFetchingBundleSurcharges: false,
    isAffiliateRepushed: false,
    isFetchingPointHistories: false,
    orderGolf: null,
    isFetchingRefunOrderPoint: false,
    refundPointSuccess: false,
    refundPointError: null,
};

export default (state = initialState, action) => {    
    switch (action.type) {
        case Types.ORDER_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.ORDER_LIST_SUCCESS:
            return { ...state, isFetching: false, data: { ...action.orders, filters: action.filters }, isSubmit: false };
        case Types.ORDER_DETAIL_ACTION:
            return { ...state, isFetching: true };
        case Types.ORDER_DETAIL_GOLF_ACTION:
            return { ...state, isFetching: true };
        case Types.ORDER_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false,
                detail: { ...state.detail, order: action.order },
                totalPrice: { totalSurcharge: action.order.totalSurcharge, totalAmount: action.order.totalAmount, totalChangeRateCode: action.order.totalChangeRateCode },
                isFetchingRecommit: false,
                isFetchingUpdateOrderStatus: false,
            };
        case Types.ORDER_DETAIL_GOLF_SUCCESS:
            const newState = {
                ...state,
                isFetching: false,
                orderGolf: action.orderGolf,
            };
            return newState;
         case Types.ORDER_FAIL_GOLF:
            return {
                ...state,
                isFetching: false,
            };
        case Types.ORDER_ITEM_GET_ACTION:
            return { ...state, isFetchingItems: true };
        case Types.ORDER_ITEM_GET_SUCCESS:
            return { ...state, isFetchingItems: false, detail: { ...state.detail, orderItem: action.orderItem } };
        case Types.ORDER_SURCHARGE_GET_ITEM_SUCCESS:
            return {
                ...state,
                isFetchingItems: false,
                detail: {
                    ...state.detail,
                    surcharges: action.surcharges.result
                }
            };
        case Types.ORDER_VOUCHER_GET_ITEM_ACTION:
            return { ...state, isFetching: true, idBooking: action.params.id };
        case Types.ORDER_FLIGHT_GET_ITEM_ACTION:
            return { ...state, isFetchingFlight: true };
        case Types.ORDER_FLIGHT_GET_ITEM_SUCCESS:
            return { ...state, isFetchingFlight: false, detail: { ...state.detail, flight: action.flight } };
        case Types.ORDER_HOTEL_GET_BOOKING_ACTION:
            return { ...state, isFetchingHotel: true };
        case Types.ORDER_HOTEL_GET_BOOKING_SUCCESS:
            return { ...state, isFetchingHotel: false, detail: { ...state.detail, reservations: action.reservations } };
        case Types.ORDER_HOMESTAY_GET_BOOKING_ACTION:
            return { ...state, isFetchingHotel: true };
        case Types.ORDER_HOMESTAY_GET_BOOKING_SUCCESS:
            return { ...state, isFetchingHotel: false, detail: { ...state.detail, reservations: action.reservations } };
        case Types.ORDER_CROSSSELL_GET_BOOKING_ACTION:
            return { ...state, isFetchingHotel: true };
        case Types.ORDER_CROSSSELL_GET_BOOKING_SUCCESS:
            return { ...state, isFetchingHotel: false, detail: { ...state.detail, reservations: action.reservations } };
        case Types.ORDER_GET_INFO_DETAIL_GROUP_SUCCESS:
            return { ...state, isFetching: false, infoDetailGroup: action.infoDetailGroup };
        case Types.ORDER_VOUCHER_GET_DETAIL_VOUCHER_ACTION:
            return { ...state, isFetching: true, isFetchingGetDetailVoucher: true };
        case Types.ORDER_VOUCHER_GET_ITEM_SUCCESS:
            return { ...state, isFetching: false, itemBooking: action.itemBooking, show: true };
        case Types.ORDER_VOUCHER_GET_DETAIL_VOUCHER_SUCCESS:
            return {
                ...state, isFetching: false,
                isFetchingGetDetailVoucher: false,
                detail: {
                    ...state.detail,
                    voucherItems: action.vouchers,
                    voucherFilters: { ...state.detail.voucherFilters, ...action.filters },
                },
            };
        case Types.ORDER_FAIL:
            return {
                ...state, isFetching: false,
                isFetchingGetDetailVoucher: false,
                isFetchingItems: false,
                isFetchingFlight: false,
                isFetchingHotel: false,
                isFetchingSaleOrder: false,
                isSubmit: false, reSendMail: false,
                isFetchingEmail: false,
                isFetchingDownload: false,
                isFetchingVinwonderCustomers: false,
                isFetchingSmsHistories: false,
                isResendSms: false,
                isFetchingPointHistories:false,
            };
        case Types.ORDER_RESEND_EMAIL_ACTION:
            return { ...state, reSendMail: true, idBooking: action.params.id };
        case Types.ORDER_RESEND_EMAIL_SUCCESS:
            return { ...state, reSendMail: false };
        case Types.ORDER_SEND_EMAIL_TEMPLATE_ACTION:
            return { ...state, isFetchingEmail: true };
        case Types.ORDER_SEND_EMAIL_TEMPLATE_SUCCESS:
            return { ...state, isFetchingEmail: false };
        case Types.ORDER_EXPORT_EXCEL_ACTION:
            return { ...state, isFetchingDownload: true }
        case Types.ORDER_EXPORT_SKU_EXCEL_ACTION:
            return { ...state, isFetchingDownload: true }
        case Types.ORDER_EXPORT_SKU_SALE_DETAIL_EXCEL_ACTION:
            return { ...state, isFetchingDownload: true }
        case Types.ORDER_EXPORT_HOTEL_SALE_DETAIL_EXCEL_ACTION:
            return { ...state, isFetchingDownload: true }
        case Types.ORDER_EXPORT_EXCEL_FAIL:
            return { ...state, isFetchingDownload: false }
        case Types.ORDER_EXPORT_EXCEL_SUCCESS:
            return { ...state, isFetchingDownload: false }
        case Types.ORDER_EXPORT_SALE_ORDER_ACTION:
            return { ...state, isFetchingSaleOrder: true, isSubmitSaleOrder: false }
        case Types.ORDER_EXPORT_SALE_ORDER_SUCCESS:
            return { ...state, isFetchingSaleOrder: false, isSubmitSaleOrder: true }
        case Types.ORDER_EXPORT_TOUR_SALE_ORDER_ACTION:
            return { ...state, isFetchingSaleOrder: true, isSubmitSaleOrder: false }
        case Types.ORDER_EXPORT_TOUR_SALE_ORDER_SUCCESS:
            return { ...state, isFetchingSaleOrder: false, isSubmitSaleOrder: true }
        case Types.ORDER_EXPORT_ACCESS_TRADE_ACTION:
            return { ...state, isFetchingDownload: true }
        case Types.ORDER_EXPORT_ACCESS_TRADE_SUCCESS:
            return { ...state, isFetchingDownload: false }
        case Types.ORDER_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.ORDER_UPDATE_SUCCESS:
            return { ...state, isFetching: false };
        case Types.ORDER_UPDATE_ACCOUNTANT_ACTION:
            return { ...state, isFetching: true };
        case Types.ORDER_UPDATE_ACCOUNTANT_SUCCESS:
            return { ...state, isFetching: false };
        case Types.ORDER_FLIGHT_UPDATE_ACTION:
            return { ...state, isFetchingEditFlight: true }
        case Types.ORDER_FLIGHT_UPDATE_SUCCESS:
            return { ...state, isFetchingEditFlight: false }
        case Types.ORDER_UPDATE_INVOICE_ACTION:
            return { ...state, isFetching: true }
        case Types.ORDER_UPDATE_INVOICE_SUCCESS:
            return { ...state, isFetching: false };
        case Types.SURCHARGE_OPEN_MODAL:
            return { ...state, openModalDetail: true };
        case Types.SURCHARGE_CLOSE_MODAL:
            return { ...state, openModalDetail: false };
        case Types.SURCHARGE_ITEM_DETAIL_SUCCESS:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    surcharge: action.surcharge
                }
            }
        case Types.GET_BUNDLE_ORDER_SURCHARGE_ACTION:
            return { ...state, isFetchingBundleSurcharges: true }
        case Types.GET_BUNDLE_ORDER_SURCHARGE_SUCCESS:
            return {
              ...state,
              isFetchingBundleSurcharges: false,
              detail: {
                  ...state.detail,
                  bundleOrderSurcharge: {
                    ...action.surcharges
                  }
              }
          }
        case Types.GET_ALL_SURCHARGE_SUCCESS:
            let listItems = [...state.detail.orderItem[action.params.listType]];
            let detailIndex = findIndex(listItems, item => {
                const field = action.params.listType === 'hotels' ? 'productVariantId' : 'itemVariantId';
                return item[field] === action.params.itemVariantId
            })

            if(action.params.listType === "vinWonders"){
                if(listItems.length > 0){
                    listItems = listItems.map((item)=>{
                        let lstItems = item.bookingItems;
                        if(lstItems){
                            let indexBookitem = findIndex(lstItems, item => {
                                return item['itemVariantId'] === action.params.itemVariantId
                            })
                            if(indexBookitem >= 0){
                                lstItems[indexBookitem].setDetail({ ...action.params, surcharges: action.surcharges });
                            }
                        }
                        return{
                            ...item,
                            bookingItems: lstItems
                        }
                    });
                }
            }else{
                if (detailIndex >= 0) listItems[detailIndex].setDetail({ ...action.params, surcharges: action.surcharges });
            }
            
            if (action.params.listType === 'hotels') {
                const listHotel = setSurchargeHotel({
                    action,
                    state,
                    surcharges: action.surcharges,
                })
                return {
                    ...state,
                    detail: {
                        ...state.detail,
                        reservations: listHotel
                    }
                }
            } else if(action.params.listType === 'vinWonders') {
                return {
                    ...state,
                    detail: {
                        ...state.detail,
                        orderItem: {
                            ...state.detail.orderItem,
                            vinWonders: listItems
                        }
                    }
                };
            }else{
                return {
                    ...state,
                    detail: {
                        ...state.detail,
                        orderItem: {
                            ...state.detail.orderItem,
                            [action.params.listType]: listItems
                        }
                    }
                };
            }
        case Types.ORDER_TOUR_RECOMMIT_ACTION:
            return { ...state, isFetchingRecommit: true }
        case Types.ORDER_TOUR_RECOMMIT_SUCCESS:
            return { ...state, isFetchingRecommit: false }
        case Types.ORDER_TOUR_RECOMMIT_FAILED:
            return { ...state, isFetchingRecommit: false }

        case Types.ORDER_ITEM_REDEEM_ACTION:
            return { ...state, isFetchingRecommit: true, recommitErr: null }
        case Types.ORDER_ITEM_REDEEM_SUCCESS:
            return { ...state, isFetchingRecommit: false }
        case Types.ORDER_ITEM_REDEEM_FAIL:
            return { ...state, isFetchingRecommit: false, recommitErr: action.error }
            
        case Types.ORDER_TOUR_UPDATE_STATUS_ACTION:
            return { ...state, isFetchingUpdateOrderStatus: true }
        case Types.ORDER_TOUR_UPDATE_STATUS_SUCCESS:
            return { ...state, isFetchingUpdateOrderStatus: false }
        case Types.ORDER_TOUR_UPDATE_STATUS_FAILED:
            return { ...state, isFetchingUpdateOrderStatus: false }
        case Types.ORDER_ITEM_CHECK_REDEEM_ACTION:
            return { ...state, isFetchingCheckRedeem: true };
        case Types.ORDER_ITEM_CHECK_REDEEM_SUCCESS:
            return { 
                ...state, 
                isFetchingCheckRedeem: false, 
                detail: { 
                    ...state.detail, 
                    redeemData: action.redeemData
                } 
            };
        case Types.ORDER_PUSH_FIXED_CHARGE_ACTION:
            return { 
                ...state, 
                isPushingFixedCharge: true
            };
        case Types.ORDER_PUSH_FIXED_CHARGE_SUCCESS:
            return { 
                ...state, 
                isPushingFixedCharge: false
            };
        case Types.ORDER_PUSH_FIXED_CHARGE_FAIL:
            return { 
                ...state, 
                isPushingFixedCharge: false
            };
        case Types.VINWONDER_CUSTOMERS_GET_LIST_ACTION:
            return { ...state, isFetchingVinwonderCustomers: true };
        case Types.VINWONDER_CUSTOMERS_GET_LIST_SUCCESS:
            return { ...state, isFetchingVinwonderCustomers: false, detail: { ...state.detail, customers: action.data }};
        case Types.SMS_HISTORIES_ACTION:
            return { ...state, isFetchingSmsHistories: true };
        case Types.SMS_HISTORIES_SUCCESS:
            return { ...state, isFetchingSmsHistories: false, detail: { ...state.detail, smsHistories: action.data }};
        case Types.SMS_RESEND_ACTION:
            return { ...state, isResendSms: true };
        case Types.SMS_RESEND_SUCCESS:
            return { ...state, isResendSms: false };
        case Types.UPDATE_PROFILE_ACTION:
            return {...state, isFetchingUpdateProfile: true};
        case Types.UPDATE_PROFILE_SUCCESS:
            return {...state,isFetchingUpdateProfile: false};
        case Types.GET_ALL_FLIGHT_TRACKING_ORDER_ACTION: {
            return {...state, isFetchingFlightTrackingOrder: true}
        }
        case Types.GET_ALL_FLIGHT_TRACKING_ORDER_SUCCESS: {
            return {...state, isFetchingFlightTrackingOrder: false, detail: {...state.detail, flightTrackingOrder: action.result}}
        }
        case Types.AFFILIATE_REPUSH_ACTION:
            return { ...state, repushAff: true, isAffiliateRepushed: false, idBooking: action.orderId };
        case Types.AFFILIATE_REPUSH_SUCCESS:
            return { ...state, repushAff: false, isAffiliateRepushed: true };
        case Types.AFFILIATE_REPUSH_FAIL:
            return { ...state, repushAff: false, isAffiliateRepushed: false };
        case Types.POINT_HISTORIES_ACTION:
            return { ...state, isFetchingPointHistories: true };
        case Types.POINT_HISTORIES_SUCCESS:
            return { ...state, isFetchingPointHistories: false, detail: { ...state.detail, pointHistories: action.data }};
        case Types.REFUND_ORDER_POINT_ACTION:
            return { ...state, isFetchingRefunOrderPoint: true, refundPointSuccess: false, refundPointError: null }
        case Types.REFUND_ORDER_POINT_SUCCESS:
            return { ...state, isFetchingRefunOrderPoint: false, refundPointSuccess: action.data.data }
        case Types.REFUND_ORDER_POINT_FAIL:
            return { ...state, isFetchingRefunOrderPoint: false, refundPointError: action.error, refundPointSuccess: false }
        default:
            return state;
    }
}
